import React from "react";
import { useParams } from "react-router-dom";
import DynamicForm from "../../components/AdvanceDynamicCreate/DynamicForm";
import { getStoredData } from "../../json/fecthData";

const DynamicCreatePage = () => {
  const { key } = useParams(); // e.g., "user", "role", "vendor", etc.
  const config = getStoredData()?.[3]?.[key];

  if (!config) return <p>❌ Invalid module config for "{key}"</p>;

  const {
    Title = "Item",
    Fields = [],
    ApiPath,
    RegisterApi,
    RedirectPath = `/${key}`
  } = config;

  return (
    <div>
      <h2>Create New {Title}</h2>
      <DynamicForm
        fields={Fields}
        apiUrl={RegisterApi || `https://hammontrackingbackend-3.onrender.com/${ApiPath}`} // fallback to generic POST
        successRedirect={RedirectPath}
      />
    </div>
  );
};

export default DynamicCreatePage;
